import { BitrixVue } from 'ui.vue';

import '../additional/additionalWrap';
import '../confirmBlock/completeButton';
import './stages/step-1/step1';
import './stages/step-2/step2';
import './stages/step-3/step3';
import './stages/step-4/step4';
import './stages/step-5/step5';
import './stages/step-6/step6';
import './stages/step-7/step7';
import './stages/step-8/step8';
import './stages/step-9/step9';
import './stages/step-10/step10';
import './stages/step-11/step11';
import './stages/step-12/step12';
import './stages/step-13/step13';
import './stages/step-14/step14';
import './stages/step-15/step15';

BitrixVue.component('Steps', {
	data() {
		return {};
	},
	props: [
		'door',
		'doorCover',
		'glazingType',
		'edgeMilling',
		'edgeColor',
		'doorType',
		'openingDoorSystem',
		'sidelines',
		'molding',
		'threshold',
		'doorTypeCanvasHeight',
		'doorTypeCanvasWidth',
		'_handleDesign',
		'handleDesignColor',
	],
	watch: {
		door: function (val, oldVAlue) {
			let keys = ['glazingType', 'glazingColor', 'glazingGlass'];
			if (val !== undefined && oldVAlue !== undefined) {
				if (Number(val.id) !== Number(oldVAlue.id)) {
					this.deletePositionKey(keys);
				}
			}

			if (!this.$store.state.basket.length) return;
		},
		doorCover: function (val, oldValue) {
			let keys = ['glazingType', 'glazingColor', 'glazingGlass', 'glazingGlass', 'doorFrameInsideElement', 'doorFrameInside', 'doorFrameOutside', 'doorFrameOutsideElement'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== undefined && oldValue !== undefined && val !== null && oldValue !== null) {
				if (val?.title !== oldValue?.title) {
					this.deletePositionKey(keys);
				}
			}
		},
		glazingType(val, oldValue) {
			let keys = ['edgeMilling', 'edgeColor'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== undefined && oldValue !== undefined) {
				if (val.id !== oldValue.id) {
					this.deletePositionKey(keys);
				}
			}
			if (!this.$store.state.basket.length) return;
		},
		edgeMilling(val, oldValue) {
			let keys = [
				'doorType',
				'doorTypeApertureHeight',
				'doorTypeConstruction',
				'doorTypeKnownSize',
				'doorTypeApertureWidth',
				'doorTypeApertureThick',
				'doorTypeCanvasHeight',
				'doorTypeCanvasWidth',
				'doorTypeCanvasThickness',
				'doorFrameSide',
				'doorTypeAdditionalCanvasHeight',
				'doorTypeAdditionalCanvasWidth',
			];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== undefined && oldValue !== undefined) {
				if (Number(val.id) !== Number(oldValue.id)) {
					this.deletePositionKey(keys);
				}
			}
			if (!this.$store.state.basket.length) return;
		},
		doorType(val, oldValue) {
			let keys = ['openingDoorSystem'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== undefined && oldValue !== undefined) {
				if (val.title !== oldValue.title) {
					this.deletePositionKey(keys);
				}
			}
			if (!this.$store.state.basket.length) return;
		},
		doorTypeCanvasHeight(val, oldVal) {
			let keys = ['openingDoorSystem'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== oldVal) {
				this.deletePositionKey(keys);
			}
		},
		doorTypeCanvasWidth(val, oldVal) {
			let keys = ['openingDoorSystem'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== oldVal) {
				this.deletePositionKey(keys);
			}
		},
		openingDoorSystem(val, oldValue) {
			let keys = ['sidelines'];
			if (val === null) {
				this.deletePositionKey(keys);
				return;
			}
			if (val !== undefined && oldValue !== undefined && oldValue !== null) {
				if (Number(val.id) !== Number(oldValue.id)) {
					this.deletePositionKey(keys);
				}
			}
			if (val === undefined) {
				this.deletePositionKey(keys);
			}

			if (!this.$store.state.basket.length) return;
		},
		sidelines(val, oldValue) {
			let keys = ['_handleDesign', 'handleDesignColor'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (val !== undefined && oldValue !== undefined) {
				if (Number(val?.id) !== Number(oldValue?.id)) {
					this.deletePositionKey(keys);
				}
			}
			if (!this.$store.state.basket.length) return;
		},
		_handleDesign(val, oldValue) {
			let keys = ['latchModel','latchZavertkaModel'];
			if (val === undefined) {
				this.deletePositionKey(keys);
				return;
			}
			if (val !== undefined && oldValue !== undefined) {
				if (val.id !== oldValue.id) {
					this.deletePositionKey(keys);
				}
			}
		},
		molding(val, oldVal) {
			let keys = ['threshold', 'doorFrameInside', 'doorFrameInsideElement', 'doorFrameOutside', 'doorFrameOutsideElement'];
			// if (val !== undefined && oldVal !== undefined) {
			// 	if (val?.id !== oldVal?.id) {
			// 		this.deletePositionKey(keys);
			// 	}
			// }

			if (val === undefined) {
				this.deletePositionKey(keys);
			}

			if (!this.$store.state.basket.length) return;
		},

		threshold(val) {
			let keys = ['doorFrameInside', 'doorFrameInsideElement', 'doorFrameOutside', 'doorFrameOutsideElement', 'step11'];
			if (val === undefined) {
				this.deletePositionKey(keys);
			}
			if (!this.$store.state.basket.length) return;
		},
	},
	methods: {
		isShowStep1: function () {
			return true;
		},
		isShowStep2: function () {
			if (this.$store.state.position.door !== undefined && !this.$store.state.position.door?.colors.length) return true;
			if (this.$store.state.position.door && this.$store.state.position.doorCover) return true;

			return false;
		},
		isShowStep3: function () {
			if (Number(this.$store.state.position.glazingType?.id) === 1) return true;
			if (Number(this.$store.state.position.glazingType?.id) !== 1 && this.$store.state.position.glazingColor && this.$store.state.position.glazingGlass) return true;

			return false;
		},

		isShowStep15: function () {
			const $edgeMilling = this.$store.state.position.edgeMilling;
			if ($edgeMilling !== undefined && $edgeMilling !== null && !$edgeMilling.colors.length) return true;
			if ($edgeMilling !== undefined && $edgeMilling !== null && $edgeMilling?.colors.length && this.$store.state.position.edgeColor) return true;
			return false;
		},

		isShowStep4: function () {
			const $edgeMilling = this.$store.state.position.edgeMilling;
			if ($edgeMilling !== undefined && $edgeMilling !== null && !$edgeMilling.colors.length) return true;
			if ($edgeMilling !== undefined && $edgeMilling !== null && $edgeMilling?.colors.length && this.$store.state.position.edgeColor) return true;
			return false;
		},
		isShowStep5: function () {
			if (this.$store.state.position.doorType?.title === 'Одностворчатая' && this.$store.state.position.doorTypeCanvasHeight && this.$store.state.position.doorTypeCanvasWidth)
				return true;
			if (
				this.$store.state.position.doorType &&
				this.$store.state.position.doorTypeConstruction &&
				this.$store.state.position.doorTypeCanvasHeight &&
				this.$store.state.position.doorTypeCanvasWidth
			)
				return true;
			return false;
		},
		isShowStep6: function () {
			if (this.$store.state.position.openingDoorSystem) return true;
			return false;
		},
		isShowStep7: function () {
			if (this.$store.state.position.sidelines) return true;
			return false;
		},
		isShowStep8: function () {
			if (this.$store.state.position._handleDesign && this.$store.state.position.handleDesignColor) return true;
			return false;
		},
		isShowStep9: function () {
			if (this.$store.state.position.latchModel) return true;

			return false;
		},
		isShowStep10: function () {
			// if (
			// 	this.$store.state.position.hingeType &&
			// 	this.$store.state.position.hingeModel
			// )
			if (this.$store.state.position._handleDesign && this.$store.state.position.handleDesignColor) return true;

			return false;
		},
		isShowStep11: function () {
			// if (this.$store.state.position.openingDoorSystem && this.$store.state.position.openingDoorSystem.moldings === undefined) return true;
			if (this.$store.state.position.molding) return true;
			return false;
		},
		isShowStep12: function () {
			const storeOpeningSystem = this.$store.state.position.openingDoorSystem;
			if (storeOpeningSystem && (storeOpeningSystem.title.toLowerCase() === 'скрытая' || Number(storeOpeningSystem.id) === 3)) return false;
			const skip = this.$store.state.position.skip11;
			if (skip !== undefined && skip === 'skip') {
				return true;
			}
			if (this.$store.state.position.threshold !== undefined) {
				return true;
			}
			return false;
		},
		isShowStep13: function () {
			const storePosition = this.$store.state.position;
			const skip = this.$store.state.position.skip12;
			if (skip !== undefined && skip === 'skip') {
				return true;
			}
			if (storePosition.doorFrameInside && storePosition.doorFrameInsideElement) return true;
			return false;
		},
		isShowStep14: function () {
			const storePosition = this.$store.state.position;
			if (storePosition.slatPlankStatus) return true;
			return false;
		},
		isShowCompleteButton: function () {
			if (this.$store.state.position.doorStopRadio.value === 0) return true;
			if (this.$store.state.position.doorStopRadio.value === 1 && this.$store.state.position.doorStopModel && this.$store.state.position.doorStopColor) return true;
			return false;
		},

		setPropPosition: function (prop) {
			this.$store.dispatch('setPosition', prop);
			this.$store.dispatch('calculateDoorNacenka');
		},
		deletePositionKey: function (keys) {
			this.$store.dispatch('deleteKeyFromPosition', keys);
		},
		setDoorPreview: function (prop) {
			this.$store.dispatch('setPreviewDoor', prop);
		},
	},
	template: `
    <div class="config-right__steps">
        <Step1 v-if="this.isShowStep1()" v-bind="this.$store.state.position"/>
        <Step2 v-if="this.isShowStep2()" v-bind="this.$store.state.position"/>
        <Step3 v-if="this.isShowStep3()" v-bind="this.$store.state.position"/>
		<Step15 v-if="this.isShowStep15()" v-bind="this.$store.state.position"/>
        <Step4 v-if="this.isShowStep4()" v-bind="this.$store.state.position"/>
        <Step5 v-if="this.isShowStep5()" v-bind="this.$store.state.position"/>
        <Step6 v-if="this.isShowStep6()" v-bind="this.$store.state.position"/>
        <Step7 v-if="this.isShowStep7()" v-bind="this.$store.state.position"/>
        <Step8 v-if="this.isShowStep8()" v-bind="this.$store.state.position"/>
        <Step9 v-if="this.isShowStep9()" v-bind="this.$store.state.position"/>
        <Step10 v-if="this.isShowStep10()" v-bind="this.$store.state.position"/>
        <Step11 v-if="this.isShowStep11()" v-bind="this.$store.state.position"/>
        <Step12 v-if="this.isShowStep12()" v-bind="this.$store.state.position"/>
        <!--<Step13 v-if="this.isShowStep13()" v-bind="this.$store.state.position"/>
        <Step14 v-if="this.isShowStep14()" v-bind="this.$store.state.position"/>-->

        <AdditionalWrap />
        <CompleteButton >
    </div>
`,
});
